import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nirf',
  templateUrl: './nirf.component.html',
  styleUrls: ['./nirf.component.scss']
})
export class NirfComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
